import React, { Component } from "react";

// import UserCredit from "../common/credit/UserCredit";

export default class TeacherCreditPage extends Component {
  render() {
    return <div>این صفحه در دست ساخت است</div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/teacher/TeacherCreditPage.js